module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_about_dmentia-c473915431604cd96ee849f84f01d7a6.png";